<template>
  <v-layout
    v-if="userData"
    :align-start="iconAlign === 'start'"
    :align-end="iconAlign === 'end'"
    :align-center="iconAlign === 'center'"
    justify-start
  >
    <v-avatar :class="[avatarCssClass]" :size="avatarSize + 'px'" color="primary">
      <v-img v-if="userData['avatar']" :src="userData.avatar"></v-img>
      <v-icon color="white" :size="avatarSize - 10 + 'px'" v-else>mdi-account-outline</v-icon>
    </v-avatar>
    <div class="og-user-avatar" :class="[textCssClass, textMarginClass]">
      <p v-if="!noName">
        <b>{{ userData.name }}</b>
        <b>
          <span v-if="showClavedat">{{ getClaveDat }}</span>
        </b>
      </p>
      <p>
        <slot></slot>
      </p>
    </div>
  </v-layout>
</template>

<script>
import UserAPI from '../../services/api/user.js';
export default {
  props: {
    user: Object,
    userId: Number,
    size: Number,
    avatarCssClass: String,
    textCssClass: String,
    noName: Boolean,
    iconAlign: {
      type: String,
      default: 'center',
    },
    showClavedat: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      demoAvatar1: '/img/image-17.png',
      userData: null,
      iconSize: 45,
      avatarSize: 60,
      textMarginClass: 'mx-2',
    };
  },
  mounted() {
    if (this.size) {
      this.iconSize = this.size * 0.9;
      this.avatarSize = this.size;
      switch (true) {
        case 50 <= this.size < 70:
          this.textMarginClass = 'mx-3';
          break;

        case 70 <= this.size < 100:
          this.textMarginClass = 'mx-4';
          break;

        case 100 <= this.size:
          this.textMarginClass = 'mx-5';
          break;

        default:
          this.textMarginClass = 'mx-2';
          break;
      }
    }
    if (!this['user'] && this['userId']) {
      this.getUser(this.userId);
    } else if (this.user) {
      this.userData = this.user;
    } else {
      this.userData = null;
    }
  },
  methods: {
    getUser(userId) {
      UserAPI.getUser(this.userId).then(res => {
        // console.log(res);
        this.userData = res.data.data;
      });
    },
  },
  computed: {
    getClaveDat() {
      if (
        this.userData &&
        this.userData.customer_profile &&
        this.userData.customer_profile.fiscal_data
      ) {
        return ' [ ' + this.userData.customer_profile.fiscal_data[0]['CLAVEDAT'] + ' ] ';
      } else {
        return null; // O cualquier valor predeterminado si no se encuentra la propiedad CLAVEDAT
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.og-user-avatar p {
  padding-top: 0px;
  padding-bottom: 0px;
  margin-bottom: 0px;
}
</style>
